export default () => {
  const forms = document.querySelectorAll('.js-add-to-cart-second-form');
  if (forms.length < 1) return
  
  ;[...forms].forEach((form) => {
    const options = form.querySelector('.js-woo-options');
    const price = form.querySelector('.js-woo-price-bar');
    const methods = form.querySelector('.c-method-cards');
    const usps = form.querySelector('.c-single-product-usps');
    
    options.remove();
    price.remove();
    methods.remove();
    usps.remove();
  })
}


// WEBPACK FOOTER //
// ./src/js/modules/PdpRemoveDoubleElements.js